import { DocumentNode, NetworkStatus, useQuery } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { useState } from 'react';
import { useDebounce } from 'use-debounce';

export const useQueryTypeahead = (
  query: DocumentNode,
  skipInitialQuery = false,
  extraVariables?: Record<string, unknown>,
) => {
  const toast = useToast();
  const [value, setValue] = useState('');

  const [debouncedValue] = useDebounce(value, 300);

  const { data, networkStatus } = useQuery(query, {
    variables: {
      query: debouncedValue || '',
      limit: 10,
      offset: 0,
      ...extraVariables,
    },
    skip: skipInitialQuery && !debouncedValue,
    onError: () => {
      toast.error({
        title: 'Failed to search',
      });
    },
    notifyOnNetworkStatusChange: true,
  });

  return {
    data,
    value,
    onValueChange: setValue,
    isLoading:
      networkStatus === NetworkStatus.loading ||
      networkStatus === NetworkStatus.setVariables,
  };
};
